// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__ORAy0","button":"ThemeToggle_button__ltJkf","buttonActive":"ThemeToggle_buttonActive__Vi-HQ","icon":"ThemeToggle_icon__Z1THH"};